import { Tooltip, TooltipProps, styled, tooltipClasses, useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { IMainCatalogItem } from '../../shared/types/main-catalog';

import './Menu.sass';
import { IArticle } from '../../shared/types/articles';
import { Util } from '../../common/util/util';
import { CustomButton } from '../Button';
import { Icon } from '../Icon';

interface IMenuProps {
  menuItems: { type?: 'li' | 'h2'; item: IMainCatalogItem }[];
  placement: 'left-start' | 'right-start';
  catalogType: 'materials' | 'equipment';
  className?: string;
  title: string;
  article: IArticle | null;
}

//Меню
export const Menu: React.FC<IMenuProps> = ({
  menuItems,
  placement,
  catalogType,
  className = '',
  title,
  article
}) => {
  const mobileScreen = useMediaQuery('(max-width:900px)');
  const textRef = useRef<any>(null);
  const [isTwoLines, setIsTwoLines] = useState(false);

  //tooltip подсказска статья
  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      borderRadius: '8px',
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 111,
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: '#fff',
      maxWidth: '500px',
      width: '100%',
    },
  }));
  //Обрезание статьи
  const textContent = (text: string) => {
    text = text.replace(/<p>(&nbsp;)?<\/p>/gi, '');
    text = text.substring(0, 333);
    let lastIndex = text.lastIndexOf(' '); // позиция последнего пробела
    text = text.substring(0, lastIndex) + '...'; // обрезаем до последнего слова
    return text;
  };
  let tooltipClass = "";
  //Для оборудования
  if(placement == 'left-start')tooltipClass = "menu__question_right_placement";

  useEffect(() => {
    if (textRef.current !== null) {
      const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight);
      const blockHeight = textRef.current.clientHeight;
      const textHeight = textRef.current.getBoundingClientRect().height;
      const maxLines = Math.floor(blockHeight / lineHeight);
      const textLines = Math.ceil(textHeight / lineHeight);

      setIsTwoLines(textLines === 2 && textLines <= maxLines);
    }
  }, [isTwoLines]);
  return (
    <div
      className={classNames('menu', className, {
        ['mobile']: mobileScreen,
      })}
    >
      <h2 className={'menu__title'}>
        {title}
        {article &&
        article?.content !== null && (
          <LightTooltip
          placement="left-end"
          title={
            <div className={"menu__question " + tooltipClass}>
              <div className="menu__question_wrapper">
                <div>
                  <Icon variant="question" />
                </div>
                <div className="menu__question_right">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: Util.textByRegex(
                            textContent(
                              article.content
                            )
                          ),
                        }}
                      ></div>
                  <CustomButton variant="orange">
                    <Link
                      to={`/articles/${article.slug}`}
                    >
                      Читать дальше
                    </Link>
                  </CustomButton>
                </div>
              </div>
            </div>
          }
        >
          <div className='menu__question_icon'>
            <Icon variant="question" />
          </div>
        </LightTooltip>
        )}
      </h2>
      <ul>
        {menuItems?.map((item) =>
          item ? (
            <Tooltip
              placement={placement}
              key={item?.item?.id}
              title={
                item &&
                item.item &&
                item?.item?.children.length > 0 &&
                item.type === 'li' ? (
                  <ul className={'menu-item__children ' + placement}>
                    {item?.item?.children.map((child) => (
                      <li key={child.id} className="menu-item__child">
                        <Link to={`/${catalogType}/${child.slug}`}>
                          {child.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <></>
                )
              }
            >
              {item && item?.type === 'h2' ? (
                <li ref={textRef} className="menu-item">
                  <Link to={`/${catalogType}/${item?.item?.slug}`}>
                    {item?.item?.title}
                  </Link>{' '}
                </li>
              ) : (
                <li ref={textRef} className="menu-item">
                  <Link to={`/${catalogType}/${item?.item?.slug}`}>
                    {item?.item?.title}
                  </Link>
                </li>
              )}
            </Tooltip>
          ) : (
            <></>
          )
        )}
      </ul>
      {(!menuItems || menuItems?.length == 0) && (
        <ul>
          {catalogType == 'materials' ? (
            <li className='menu-item'>
              Соответствующих материалов пока нет
            </li>
          ) : (
            <li className='menu-item'>
              Соответствующего оборудования пока нет
            </li>
          )}
        </ul>
      )}
    </div>
  );
};
